<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="row mb-3">
          <div class="col-lg-12">
            <v-expansion-panels flat popout hover>
              <v-expansion-panel
              >
                <v-expansion-panel-header class="bg-light">
                  <span><v-icon left>mdi-magnify</v-icon>Detaylı Arama</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="container-xxl-fluid">
                    <div class="row">
                      <div class="col-lg-3">
                        <v-menu
                            transition="scale-transition"
                            offset-y
                            :close-on-content-click="false"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDate(dateRangeStart)"
                                label="Tarih Aralık Başlangıç"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                filled
                                solo
                                dense
                                clearable
                                @click:clear="dateRangeStart = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateRangeStart"
                              locale="tr"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="col-lg-3">
                        <v-menu
                            transition="scale-transition"
                            offset-y
                            :close-on-content-click="false"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDate(dateRangeEnd)"
                                label="Tarih Aralık Bitiş"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                filled
                                solo
                                dense
                                clearable
                                @click:clear="dateRangeEnd = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateRangeEnd"
                              locale="tr"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="col-lg-3" v-if="user.RoleGroupId !== '3'">
                        <search-select
                            :search-type="'current'"
                            @itemChange="(e) => (selectedCurrent = e)"
                            :label="'Cari'"
                        >
                        </search-select>
                      </div>
                      <div class="col-lg-3" v-if="user.RoleGroupId === '1'">
                        <v-select
                            v-model="salesPersonCode"
                            label="Plasiyer"
                            filled
                            solo
                            dense
                            :items="salesPersonList"
                            :item-text="item => item.name"
                            :item-value="item => item.code"
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <search-select
                            :search-type="'project'"
                            @itemChange="(e) => (selectedProject = e)"
                            :label="'Proje'"
                        >
                        </search-select>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="orderStatus"
                            label="Durumu"
                            filled
                            solo
                            dense
                            :items="statusOptions"
                            :item-text="item => item.text"
                            :item-value="item => item.value"
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="paymentMethodId"
                            filled
                            label="Ödeme Yöntemi"
                            dense
                            solo
                            :items="paymentMethodList"
                            :item-text="item => item.name"
                            :item-value="item => item.id"
                            persistent-hint
                        ></v-select>
                      </div>
                      <div class="col-lg-12 text-end">
                        <v-btn
                            color="primary darken-1"
                            small
                            @click="fetchData"
                        >
                          <v-icon left>mdi-magnify</v-icon>
                          Filtrele
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div class="col-lg-12 d-flex flex-wrap">
            <div>
              <p class="text-center">Gösterilen Kayıt Sayısı</p>
              <v-btn-toggle mandatory solo dense>
                <v-btn @click="perPage = 10"> 10 </v-btn>
                <v-btn @click="perPage = 20"> 20 </v-btn>
                <v-btn @click="perPage = 30"> 30 </v-btn>
                <v-btn @click="perPage = 50"> 50 </v-btn>
              </v-btn-toggle>
            </div>
            <div class="ms-auto">
              <v-btn v-if="user.RoleGroupId === '1'" class="mt-3" small color="primary darken-4" :loading="orderInvoiceControlLoading" @click="_invoiceControlOrder"><v-icon left>mdi-file-document-alert</v-icon>ERP FATURA DURUM KONTROL</v-btn>
              <v-text-field
                  v-model="searchText"
                  class="mt-5 pt-3"
                  outlined
                  rounded
                  dense
                  placeholder="Arama Yapın..."
                  clearable
                  hide-details
                  append-icon="mdi-magnify"
                  @click:append="fetchData"
                  @keydown.enter="fetchData"
              ></v-text-field>
            </div>
          </div>
        </div>
        <div class="row">
          <p class="text-start">Toplam <b>{{ B2BOrdersMetaData.totalCount }}</b> Kayıt Bulundu</p>
          <ResultTableView :perPage="perPage"></ResultTableView>
        </div>
        <!-- end row -->

        <div class="row">
          <div class="col-lg-12 mb-5">
            <v-pagination
                v-model="currentPage"
                class="my-4"
                :length="B2BOrdersMetaData.totalPages"
                :total-visible="20"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import ResultTableView from "@/components/orders/B2BOrders/results/ResultsTableView";
import {formattedDate} from "@/momentHelper";
import { mapState, mapActions } from "vuex";
import SearchSelect from "@/components/searchSelect.vue";
import ResultsMixin from "@/mixins/ResultsMixin";

export default {
  components: {
    SearchSelect,
    ResultTableView
  },
  mixins: [ResultsMixin],
  props:{
    listType:{
      type: String,
      default: "SiparisList"
    }
  },
  mounted() {
    //this.getOrders(this.listType);
    this.fetchSalesPersonList({
      params: {

      },
      body: {

      }
    });
    this.fetchPaymentMethodList({
      params: {
        userId: this.user.UserId
      },
      body: {}
    })
  },
  computed: {
    ...mapState("order", ["B2BOrders","B2BOrdersHeaders","B2BOrdersLoading","B2BOrdersMetaData","orderInvoiceControlLoading"]),
    ...mapState("current",["salesPersonList"]),
    ...mapState("auth",["user"]),
    ...mapState("payment", ["paymentMethodList"]),
    ...mapState("settings",["erpSettings"]),
    statusOptions: function () {
      let options = [
        {value: null, text: 'Tüm Durumlar'},
        {value: 1, text: 'Beklemede'},
        {value: 2, text: 'Onaylandı'},
        {value: 3, text: 'Faturalandı'},
        {value: 4, text: 'Reddedildi'}]
      if (this.erpSettings.cartProjectProcess)
        options.push({value: 5, text: 'Proje Aşamasında'},{value: 6, text: 'Sipariş Aşamasında'})
      return options;
    }
    // setDetailedFilters () {
    //   return {
    //     ...(this.user.RoleGroupId === "3") && {currentCode: this.user.userInfo.erpCode},
    //     ...(this.user.RoleGroupId === "2") && {salesPersonCode: this.user.SalesPersonCode},
    //     ...(!(this.searchText === "" || this.searchText === null)) && {searchText: this.searchText},
    //     ...(this.orderNumberValue != null && {orderNumber: this.orderNumberValue}),
    //     ...(this.dateRangeStart && {startDate: this.dateRangeStart}),
    //     ...(this.dateRangeEnd && {finishDate: this.dateRangeEnd}),
    //     ...(this.salesPersonCode && {salesPerson: this.salesPersonCode}),
    //     ...(this.selectedCurrent && {currentCode: this.selectedCurrent}),
    //     ...(this.statusValue != null && {status: this.statusValue}),
    //     ...(this.paymentMethodId != null && {paymentMethodId: this.paymentMethodId}),
    //   };
    // }
  },
  data() {
    return {
      selectedCurrent: null,
      currentSearchText: null,
      searchCurrentLoading: false,
      currentSearchResult:[],
      searchCurrentTimeout: null,
      dateRangeStart: null,
      dateRangeEnd: null,
      searchText: null,
      orderStatus: null,
      salesPersonCode: null,
      paymentMethodId: null,
      filters: {
        pageNumber: null,
        pageSize: null,
        userId: null,
      },
      detailedFilters: {},
      selectedProject: null,
    };
  },
  methods: {
    formattedDate,
    ...mapActions("order", ["fetchB2BOrders", "invoiceControlOrder"]),
    ...mapActions("current", ["fetchSalesPersonList", "fetchCurrentList"]),
    ...mapActions("payment", ["fetchPaymentMethodList"]),
    _invoiceControlOrder() {
      this.invoiceControlOrder({
        params: {},
        text: {}
      }).then(async () => {
        await this.fetchData()
      })
    },
    async fetchData() {
      this.filters = {
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        userId: this.user.UserId,
      }
      this.detailedFilters = {
        ...(this.user.RoleGroupId === "3") && {currentCode: this.user.userInfo.erpCode},
        ...(this.user.RoleGroupId === "2") && {salesPersonCode: this.user.SalesPersonCode},
        ...(!(this.searchText === "" || this.searchText === null)) && {searchText: this.searchText},
        ...(this.dateRangeStart && {startDate: this.dateRangeStart}),
        ...(this.dateRangeEnd && {finishDate: this.dateRangeEnd}),
        ...(this.salesPersonCode && {salesPersonCode: this.salesPersonCode}),
        ...(this.selectedCurrent && {currentCode: this.selectedCurrent}),
        ...(this.orderStatus != null && {orderStatus: this.orderStatus}),
        ...(this.paymentMethodId != null && {paymentMethodId: this.paymentMethodId}),
        ...(this.selectedProject != null && {projectCode: this.selectedProject}),
      }
      let params = Object.assign({}, this.filters, this.detailedFilters);
      await this.fetchB2BOrders({
        params: params,
        body: {}
      })
      this.updateUrl();
    },
    async _fetchCurrentList() {
      this.currentSearchResult = [];
      this.currentSearchResult = setTimeout(async () => {
        await this.fetchCurrentList({
          params: {
            userId: this.user.UserId,
            pageNumber: 1,
            pageSize: 50,
            ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2 ? true : false) && {salesPersonCode: this.user.SalesPersonCode},
            ...(this.currentSearchText == "" || this.currentSearchText == null ? false : true) && {searchText: this.currentSearchText}
          },
          body: {},
          onlyData: true,
          loading: false
        });
      }, 1500)

      this.searchCurrentLoading = false
    }
  },
  watch: {
    currentSearchText: function (newVal) {
      if (newVal && (newVal.length > 2)) {
        if (this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
        this.searchCurrentLoading = true
        this.currentSearchResult = [];
        this.searchCurrentTimeout = setTimeout(() => {

          this._fetchCurrentList();
        }, 1500);
      } else {
        this.searchCurrentLoading = false;
        if (this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
      }
    },

    //TODO REVIEW, detailedFilters nested olarak takip edilmiyor.
    "detailedFilters.searchText": function (newVal) {
      newVal;
      this.currentPage = 1
    },
    "detailedFilters.currentCode": function (newVal) {
      newVal;
      this.currentPage = 1
    },
    "detailedFilters.salesPersonCode": function (newVal) {
      newVal;
      this.currentPage = 1
    },
    "detailedFilters.startDate": function (newVal) {
      newVal;
      this.currentPage = 1
    },
    "detailedFilters.finishDate": function (newVal) {
      newVal;
      this.currentPage = 1
    },
    "detailedFilters.orderStatus": function (newVal) {
      newVal;
      this.currentPage = 1
    },
  }
};
</script>